import { gql } from '@grandvisionhq/graphql';
import { cartDetails } from '../fragments/cart-details.js';
import { cartValidationErrors } from '../fragments/cart-validation-errors.js';
import '../fragments/recover-inactive-cart-failure.js';
import '../fragments/recover-inactive-cart-result.js';

const CREATE_CART = gql`
  mutation CreateCart($cartInput: CreateCartInput!) {
    createCart(cartInput: $cartInput) {
      cart {
        ...CartDetailsFragment
        prescriptionSignatures
      }
      cartHash
      validationErrors {
        ...CartValidationErrorsFragment
      }
      success
    }
  }
  ${cartDetails}
  ${cartValidationErrors}
`;

export { CREATE_CART };
//# sourceMappingURL=create-cart.js.map
